import React from 'react';
import { Outlet } from 'react-router-dom';

function CMSLayout() {
  return <Outlet />;
}

export default CMSLayout;
